import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home/Home'
import AboutiFREE from '@/components/AboutiFREE/AboutiFREE'
import ContactUs from '@/components/ContactUs/ContactUs'
import Services from '@/components/Services/Services'
import ProductDetails from '@/components/ProductDetails/ProductDetails.vue'
import iDual from '@/components/ProductDetails/iGO/iDual.vue'
import ShoppingCart from '@/components/ShoppingCart/ShoppingCart.vue'
import MyDetails from '@/components/MyDetails/MyDetails.vue'
import PurchaseSucceeds from '@/components/MyDetails/PurchaseSucceeds.vue'
import Settlement from '@/components/MyDetails/Settlement.vue'
import Reset from '@/components/ResetPassword/ResetPassword.vue'
import Cable from '@/components/ProductDetails/iGO/Cable.vue'
import P5 from '@/components/ProductDetails/iGO/P5.vue'
import P9 from '@/components/ProductDetails/iGO/P9.vue'
import S1 from '@/components/ProductDetails/iGO/S1.vue'
import M1 from '@/components/ProductDetails/iGO/M1.vue'
import iglobal from '@/components/ProductDetails/iglobal.vue'
import ichat from '@/components/ProductDetails/ichat.vue'
import Personal from '../components/Profiler/Personal.vue'
import iPointSuccess from '../components/Profiler/iPointSuccess.vue'
import iPointError from '../components/Profiler/iPointError.vue'
import iPointTransfer from '../components/Profiler/iPointTransfer.vue'
import ProblemList from '../components/Services/ProblemList.vue'
import problemContent from '../components/Services/ProblemContent.vue'
import ProblemSearch from '../components/Services/ProblemSearch.vue'
import Profile from '../components/Profiler/Profile.vue'
import Order from '../components/Profiler/Order.vue'
import iPoint from '../components/Profiler/iPoint.vue'
import Coupons from '../components/Profiler/Coupons.vue'
import iAPP from '../components/Profiler/iAPP.vue'
import Ongoing from '../components/Profiler/Order/Ongoing.vue'
import EndOrder from '../components/Profiler/Order/EndOrder.vue'
import Cart from '../components/Profiler/Order/ShoppingCart.vue'
import Search from '../components/Home/Search.vue'
import SearchAll from '../components/Search/All.vue'
import SearchProduct from '../components/Search/Product.vue'
import SearchStore from '../components/Search/Store.vue'
import SearchSupport from '../components/Search/Support.vue'
import Shop from '../components/Shop.vue'
import Aftermarket from '../components/MyDetails/Aftermarket.vue'
import mogos from '../components/ProductDetails/mogos.vue'
import iAdapter from '../components/ProductDetails/iGO/iAdapter.vue'
import App from '../components/iApp/iapp.vue'
import terms_of_service from '../components/Common/termsOfService.vue'
import privacy_policy from '../components/Common/privacy_policy.vue'
import sales_and_refund from '../components/Common/Sales_and_Refund.vue'
import Local from '../lib/Local'
import terms_of_law from  '../components/Common/terms_of_law.vue'
import information from  '../components/Home/Information.vue'
import ConsultationDetails from '../components/Home/ConsultationDetails.vue'
// import QuestionCategory from '../components/Services/QuestionCategory.vue'
import Login from '../components/Home/Login.vue'
import Register from '../components/Home/Register.vue'
import Go from '../components/Go/Go.vue'
import FooterShop from '../components/Home/FooterShop.vue'
import Tranvelution from '../components/Tranvelution/Tranvelution.vue'
import PhysicalStore from '../components/Store/PhysicalStore.vue'
import iVoice from '../components/iVoice/iVoice.vue'
import Free from '../components/Free/Free.vue'
import HowTobuy from '../components/HowTobuy.vue'
import Confirmation from '../components/MyDetails/Confirmation.vue'
import Connect from '../components/Connect/Connect.vue'

Vue.use(Router)
const notToTop = [
    'Ongoing',
    'EndOrder',
    'Cart'
]
export default new Router({
    mode: 'history',
    scrollBehavior (to, from, savedPosition) {
        if (notToTop.indexOf(to.name) === -1) {
            return {x: 0, y: 0}
        }
    },
    routes: [
        {
            path: '/',
            name: 'Home',
            component: Home
        },
        {
            path: '/search',
            name: 'Search',
            component: Search,
            redirect: to => {
                return {
                    name: 'SearchAll',
                    params: {
                        type: '1'
                    }
                }
            },
            children: [
                {
                    path: 'all',
                    name: 'SearchAll',
                    component: SearchAll
                },
                {
                    path: '/product',
                    name: 'SearchProduct',
                    component: SearchProduct
                },
                {
                    path: '/store_list',
                    name: 'SearchStore',
                    component: SearchStore
                },
                {
                    path: '/support',
                    name: 'SearchSupport',
                    component: SearchSupport
                }
            ]
        },
        {
            path: '/about',
            name: 'AboutiFREE',
            component: AboutiFREE
        },
        {
            path: '/contact',
            name: 'ContactUs',
            component: ContactUs
        },
        {
            path: '/Store',
            name: 'Shop',
            component: Shop
        },
        {
            path: '/answers/:id?',
            name: 'problemContent',
            component: problemContent
        },
        {
            path: '/results',
            name: 'problemSearch',
            component: ProblemSearch
        },
        {
            path: '/support',
            name: 'Services',
            component: Services,
            redirect: to => {
                return {
                    name: 'problemList',
                    params: {
                        type: '1'
                    }
                }
            },
            children: [
                {
                    path: '/support/:type?',
                    name: 'problemList',
                    component: ProblemList

                }
            ]
        },
        {
            path: '/personal_info',
            name: 'Personal',
            beforeEnter: (to, from, next) => {
                // 判断过期
                let timestamp = Date.parse(new Date()) / 1000
                let timeLength = 3200
                if (Local.get('timeout') + timeLength < timestamp) {
                    Local.unset('timeout')
                    Local.unset('users')
                } else {
                    Local.set('timeout', timestamp)
                }

                if (!Local.get('users')) {
                    console.log(to.path.indexOf('Personal'))
                    if (to.path.indexOf('Personal') <= 0) {
                        Local.set('isLogin', 0)
                        next({path: '/Login'})
                    } else {
                        next()
                    }
                } else {
                    next()
                }
            },
            component: Personal,
            redirect: to => {
                return {name: 'Profile'}
            },
            children: [
                {
                    path: '/profile',
                    name: 'Profile',
                    component: Profile
                },
                {
                    path: '/order',
                    name: 'Order',
                    component: Order,
                    redirect: to => {
                        return {name: 'Ongoing'}
                    },
                    children: [
                        {
                            path: '/current',
                            name: 'Ongoing',
                            component: Ongoing
                        },
                        {
                            path: '/endorder',
                            name: 'EndOrder',
                            component: EndOrder
                        },
                        {
                            path: '/cart',
                            name: 'Cart',
                            component: Cart
                        }
                    ]
                },
                {
                    path: 'ipoint',
                    name: 'iPoint',
                    component: iPoint
                },
                {
                    path: 'coupons',
                    name: 'Coupons',
                    component: Coupons
                },
                {
                    path: 'iapp',
                    name: 'iAPP',
                    component: iAPP
                }
            ]
        },
        {
            path: '/user/order/:order_sn/detail',
            name: 'MyDetails',
            component: MyDetails
        },
        {
            path: '/ipoint-success',
            name: 'iPointSuccess',
            component: iPointSuccess
        },
        {
            path: '/ipoint-error',
            name: 'iPointError',
            component: iPointError
        },
        {
            path: '/ipoint-transfer',
            name: 'iPointTransfer',
            component: iPointTransfer
        },
        {
            path: '/product/:id(\\d+)',
            name: 'ProductDetails',
            component: ProductDetails
        },
        {
            path: '/shopping',
            name: 'ShoppingCart',
            component: ShoppingCart
        },
        {
            path: '/Reset',
            name: 'Reset',
            component: Reset
        },
        {
            path: '/buy/checkout',
            name: 'Settlement',
            component: Settlement
        },
        {
            path: '/user/order/success',
            name: 'PurchaseSucceeds',
            component: PurchaseSucceeds
        },
        {
            path: '/user/order/:order_sn/aftermarket',
            name: 'Aftermarket',
            component: Aftermarket
        },
        {
            path: '/product/idual',
            name: 'iDual',
            component: iDual
        },
        {
            path: '/product/2in1_cable',
            name: 'Cable',
            component: Cable
        },
        {
            path: '/product/p5',
            name: 'P5',
            component: P5
        },
        {
            path: '/product/p9',
            name: 'P9',
            component: P9
        },
        {
            path: '/product/s1',
            name: 'S1',
            component: S1
        },
        {
            path: '/product/m1',
            name: 'M1',
            component: M1
        },
        {
            path: '/product/iglobal',
            name: 'iglobal',
            component: iglobal
        },
        {
            path: '/product/ichat',
            name: 'ichat',
            component: ichat
        },
        {
            path: '/product/mogos',
            name: 'mogos',
            component: mogos
        },
        {
            path: '/product/iadapter',
            name: 'iAdapter',
            component: iAdapter
        },
        {
            path: '/iapp',
            name: 'app',
            component: App
        },
        {
            path: '/terms_of_conditions',
            name: 'terms_of_service',
            component: terms_of_service
        },
        {
            path: '/privacy_policy',
            name: 'privacy_policy',
            component: privacy_policy
        },
        {
            path: '/sales_and_refund',
            name: 'sales_and_refund',
            component: sales_and_refund
        },
        {
            path: '/terms_of_law',
            name: 'terms_of_law',
            component: terms_of_law
        },
        {
            path: '/newsroom',
            name: 'information',
            component: information
        },
        {
            path: '/news',
            name: 'ConsultationDetails',
            component: ConsultationDetails
        },
        {
            path: '/login',
            name: 'Login',
            component: Login

        },
        {
            path: '/register',
            name: 'Register',
            component:Register
        },
        {
            path: '/igo',
            name: 'Go',
            component: Go
        },
        {
            path: '/shop',
            name: 'FooterShop',
            component: FooterShop
        },
        {
            path: '/travelution',
            name: 'Tranvelution',
            component: Tranvelution
        },
        {
            path: '/iretail',
            name: 'PhysicalStore',
            component: PhysicalStore
        },
        {
            path: '/ivoice',
            name: 'iVoice',
            component: iVoice
        },
        {
            path: '/gift',
            name: 'Free',
            component: Free
        },
        {
            path: '/howtopurchase',
            name: 'HowTobuy',
            component:HowTobuy
        },
        {
            path: '/confirmation',
            name: 'Confirmation',
            component: Confirmation
        },
        {
            path: '/iconnect',
            name: 'Connect',
            component: Connect
        }

    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js